import React from 'react';
import { Link, useNavigate } from 'react-router-dom';


function AboutMzansiStokvel() {
  return (
    <section className="relative bg-gray-50 text-gray-800">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <div className="flex items-center gap-3">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#152d4d]">
            About Mzansi Stokvel
          </h2>
          <span className="hidden md:inline-flex h-1 w-20 rounded bg-[#26C6DA]" />
        </div>

        {/* Intro text */}
        <p className="mt-4 text-gray-700 leading-relaxed max-w-3xl">
          We modernise South Africa&apos;s stokvel tradition with{" "}
          <span className="font-semibold text-[#26C6DA]">secure</span>,{" "}
          <span className="font-semibold text-[#26C6DA]">transparent technology</span>{" "}
          and <span className="font-semibold text-[#26C6DA]">community-first education</span>.
          Together we&apos;re building a future where millions can save safely, earn interest, and grow wealth.
        </p>

        {/* Features with iconography */}
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {/* Feature 1 */}
          <div className="flex gap-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
              {/* mobile icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect x="7" y="2" width="10" height="20" rx="2" stroke="#26C6DA" strokeWidth="1.5" />
                <circle cx="12" cy="18" r="1" fill="#26C6DA" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[#152d4d]">Simple, mobile-first experience</h3>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex gap-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
              {/* QR code icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M4 4h6v6H4V4zM14 4h6v6h-6V4zM4 14h6v6H4v-6zM16 14h2v2h-2v-2zM20 18h-2v2h-2v-2h-2v-2h6v4z" stroke="#26C6DA" strokeWidth="1.5" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[#152d4d]">QR code or link invites</h3>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="flex gap-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
              {/* shield/heart icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M12 21s8-4 8-11V5l-8-3-8 3v5c0 7 8 11 8 11z" stroke="#26C6DA" strokeWidth="1.5" />
                <path d="M9 10c0-1 .8-2 2-2s2 1 2 2-2 3-2 3-2-2-2-3z" stroke="#26C6DA" strokeWidth="1.5" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[#152d4d]">Optional funeral policy via the app</h3>
            </div>
          </div>

          {/* Feature 4 */}
          <div className="flex gap-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
              {/* savings icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="#26C6DA" strokeWidth="1.5" />
                <path d="M12 7v5l3 2" stroke="#26C6DA" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[#152d4d]">
                Investment nudges: transfer a portion of payouts into a savings wallet
              </h3>
            </div>
          </div>
        </div>

        {/* Logos */}
        <div className="mt-12 flex flex-wrap items-center justify-center md:justify-between gap-8">
          <div className="">
          <Link
            to="/about-us"
            className="inline-flex items-center justify-center rounded-lg px-6 py-3 text-white bg-[#26C6DA] font-medium shadow-sm transition hover:bg-[#1f4e79] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#26C6DA]"
          >
            Read More
          </Link>
        </div>
          <div className='flex gap-10'>
            <div className="flex items-center justify-center bg-white rounded-lg shadow-sm px-6 py-3">
              <img src="/Images/sharenet.jpg" alt="Sharenet Logo" className="h-8" />
            </div>
          </div>
        </div>

        {/* CTA Button */}
        
      </div>
    </section>
  );
}


/**
 * Mzansi How It Works Section
 * --------------------------------------------------------
 * - Clean white/grey surfaces, navy headings, turquoise accents
 * - Subtle pattern strip, icon badges, accent bars, soft hover states
 * - Accessible CTAs with focus rings
 *
 * Tailwind: assumes your app already includes Tailwind CSS
 */

function MzansiHowItWorksSection(
  howItWorksHref = "/how-it-works",
  faqHref = "/faq",
  pricingHref = "/pricing",
) {
  return (
    <section className="relative py-16 bg-gray-50 text-gray-800">
      {/* subtle dotted pattern strip (brand accent) */}
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-16 opacity-10"
        style={{
          backgroundImage: "radial-gradient(#26C6DA 1px, transparent 1px)",
          backgroundSize: "14px 14px",
        }}
      />

      <div className="max-w-6xl mx-auto px-6">
        {/* Eyebrow + Heading */}
        <p className="text-sm font-semibold tracking-widest uppercase text-[#26C6DA]">
          Mzansi Stokvel
        </p>
        <div className="flex items-center gap-3 mt-2">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#152d4d]">
            How It Works
          </h2>
          <span className="hidden md:inline-flex h-1 w-24 rounded bg-[#26C6DA]" />
        </div>
        <p className="mt-3 text-gray-600">
          Leaders have control and members have visibility —
          <span className="text-[#26C6DA] font-semibold"> full transparency builds trust.</span>
        </p>
        <p className="mt-1 text-sm text-gray-500">
          Managed by <span className="font-medium text-[#152d4d]">Sharenet</span>
        </p>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-6 mt-10">
          {/* Card: Leaders */}
          <article
            className="group relative bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden transition hover:shadow-md hover:-translate-y-0.5"
            aria-labelledby="leaders-title"
          >
            {/* accent bar */}
            <div className="absolute inset-x-0 top-0 h-1.5 bg-[#152d4d]" />

            <div className="p-6 md:p-7">
              {/* icon badge */}
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
                {/* crown icon */}
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 8l4 3 4-6 4 6 4-3v9H4V8z" stroke="#26C6DA" strokeWidth="1.5" strokeLinejoin="round" />
                </svg>
                <span className="sr-only">For Leaders</span>
              </div>

              <h3 id="leaders-title" className="mt-4 text-xl font-semibold text-[#152d4d]">
                For Leaders
              </h3>
              <ul className="mt-4 space-y-2.5">
                {[
                  "Register your stokvel group in minutes",
                  (
                    <>
                      Invite with a unique <span className="font-semibold text-[#26C6DA]">QR code</span> or link
                    </>
                  ),
                  (
                    <>
                      Set the rules: <em>minimum contribution</em> and due dates
                    </>
                  ),
                  (
                    <>
                      See <span className="font-semibold text-[#26C6DA]">all group transactions</span> and interest at a glance
                    </>
                  ),
                ].map((item, idx) => (
                  <li key={idx} className="flex gap-3">
                    <span className="mt-1 inline-block w-2 h-2 rounded-full bg-[#26C6DA]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 flex items-center gap-3">
                <Link
                  to='/how-it-works'
                  className="inline-flex items-center justify-center rounded-lg px-5 py-2.5 text-white bg-[#26C6DA] font-medium shadow-sm transition hover:bg-[#1f4e79] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#26C6DA]"
                >
                  Read More
                </Link>
                <Link to='/how-it-works' className="text-sm text-[#1f4e79] hover:underline">
                  See FAQs
                </Link>
              </div>
            </div>
          </article>

          {/* Card: Members */}
          <article
            className="group relative bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden transition hover:shadow-md hover:-translate-y-0.5"
            aria-labelledby="members-title"
          >
            <div className="absolute inset-x-0 top-0 h-1.5 bg-[#152d4d]" />

            <div className="p-6 md:p-7">
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
                {/* users icon */}
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M16 14a4 4 0 10-8 0v2h8v-2z" stroke="#26C6DA" strokeWidth="1.5" />
                  <circle cx="12" cy="8" r="3.5" stroke="#26C6DA" strokeWidth="1.5" />
                </svg>
                <span className="sr-only">For Members</span>
              </div>

              <h3 id="members-title" className="mt-4 text-xl font-semibold text-[#152d4d]">
                For Members
              </h3>
              <ul className="mt-4 space-y-2.5">
                {[
                  "Join via QR code or link",
                  (
                    <>
                      Deposit safely and <span className="font-semibold text-[#26C6DA]">earn interest</span> on savings
                    </>
                  ),
                  (
                    <>
                      Track your <span className="font-semibold text-[#26C6DA]">balance</span> and interest in real time
                    </>
                  ),
                  (
                    <>
                      Withdraw to <span className="font-semibold text-[#26C6DA]">Visa/Mastercard</span> or a virtual card
                    </>
                  ),
                ].map((item, idx) => (
                  <li key={idx} className="flex gap-3">
                    <span className="mt-1 inline-block w-2 h-2 rounded-full bg-[#26C6DA]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 flex items-center gap-3">
                <Link
                  to='/how-it-works'
                  className="inline-flex items-center justify-center rounded-lg px-5 py-2.5 text-white bg-[#26C6DA] font-medium shadow-sm transition hover:bg-[#1f4e79] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#26C6DA]"
                >
                  Read More
                </Link>
                <Link to="/how-it-works" className="text-sm text-[#1f4e79] hover:underline">
                  View Pricing
                </Link>
              </div>
            </div>
          </article>
        </div>

        {/* Card: Redemption */}
        <article
          className="relative bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mt-6 transition hover:shadow-md hover:-translate-y-0.5"
          aria-labelledby="redemption-title"
        >
          <div className="absolute inset-x-0 top-0 h-1.5 bg-[#152d4d]" />

          <div className="p-6 md:p-7">
            <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#E6FAFD] ring-1 ring-[#26C6DA]/30">
              {/* card icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="6" width="18" height="12" rx="2" stroke="#26C6DA" strokeWidth="1.5" />
                <path d="M3 10h18" stroke="#26C6DA" strokeWidth="1.5" />
              </svg>
              <span className="sr-only">Smart Redemption & Investing</span>
            </div>

            <h3 id="redemption-title" className="mt-4 text-xl font-semibold text-[#152d4d]">
              Smart Redemption &amp; Investing
            </h3>
            <p className="mt-3 text-gray-700">
              Redeem at large retailers with member discounts. We’ll nudge you to keep building wealth —
              <span className="font-semibold text-[#26C6DA]"> transfer part of your payout into an investment/savings wallet</span>
              instead of cashing everything out.
            </p>

            <div className="mt-6">
              <a
                href={howItWorksHref}
                className="inline-flex items-center justify-center rounded-lg px-5 py-2.5 text-white bg-[#26C6DA] font-medium shadow-sm transition hover:bg-[#1f4e79] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#26C6DA]"
              >
                Read More
              </a>
            </div>
          </div>
        </article>

        {/* Section footer note */}
        <div className="mt-10 flex flex-wrap items-center gap-3 text-sm text-gray-500">
          <span className="inline-flex items-center gap-2">
            <span className="inline-block h-2 w-2 rounded-full bg-[#26C6DA]" /> Transparent reporting
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block h-2 w-2 rounded-full bg-[#26C6DA]" /> Community-first design
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block h-2 w-2 rounded-full bg-[#26C6DA]" /> Bank-grade security
          </span>
        </div>
      </div>
    </section>
  );
}



const MzansiStokvel = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen">
      {/* Custom CSS Variables and Styles */}
      <style jsx>{`
        :root {
          --blue: #0A2850;
          --blue-2: #152d4d;
          --turquoise: rgb(38,198,218);
          --grey: #f5f7fa;
          --text: #0f172a;
          --muted: #475569;
        }
         @media screen and (max-width: 768px) { 
          h1 {
            font-size:2rem !important
          }
      }
      `}</style>

      {/* Hero Section */}
      <section 
        id="home" 
        className="relative text-white py-24 bg-cover bg-center bg-no-repeat"
        style={{
            
                background:' radial-gradient(1200px 800px at 70% 10%, rgba(255,255,255,0.08), rgba(0,0,0,0.85)),url("Images/home.png") right center/cover no-repeat',
              }}
      >
        <div className="container mx-auto px-5 max-w-6xl">
          <div className="flex items-center gap-10">
            <div className="flex-1">
              <span className="inline-block bg-cyan-400 text-cyan-900 px-3 py-1.5 rounded-full text-xs font-bold tracking-wide">
                Safe • Simple • Smart
              </span>
              <h1 className="text-[2rem] font-bold leading-tight mt-3 mb-3">
                Saving Together — The Modern Stokvel
              </h1>
              <p className="text-lg max-w-3xl mb-5">
                Run your stokvel the smart way. Built for security, managed by <strong>Sharenet</strong> for financial expertise,
                and built on <strong>blockchain transparency</strong>. Earn interest on savings, enjoy retailer discounts,
                and get safe Visa/Mastercard or virtual-card payouts.
              </p>
              <div className="flex gap-3 flex-wrap">
               <a
                    href="http://mzansisave.co.za/msansisave.apk"
                    download="mzansisave.apk"
                    className="bg-cyan-400 text-white px-5 py-3 rounded-lg font-bold text-decoration-none hover:bg-cyan-500 transition-colors"
                  >
                    Join as a Member
                  </a>

                <Link 
                  to="/graduate-agents" 
                  className="border-2 border-white text-white bg-transparent px-5 py-3 rounded-lg font-bold text-decoration-none hover:bg-white hover:text-gray-900 transition-colors"
                >
                  Become a Graduate Agent
                </Link>
                <Link 
                  to="/how-it-works" 
                  className="bg-gray-100 text-gray-900 px-5 py-3 rounded-lg font-bold text-decoration-none hover:bg-gray-200 transition-colors"
                >
                  Learn How It Works
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how" className="py-16">
        <MzansiHowItWorksSection/>
        {/* <div className="container mx-auto px-5 max-w-6xl">
          <h2 className="text-3xl font-bold mb-2">How It Works</h2>
          <p className="text-gray-600 mb-6">Leaders have control and members have visibility — full transparency builds trust.</p>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-4">For Leaders</h3>
              <ul className="space-y-2 ml-5">
                <li>Register your stokvel group in minutes</li>
                <li>Share a unique <strong>QR code or link</strong> to invite members</li>
                <li>Set the rules: <em>minimum contribution</em> and <em>due dates</em></li>
                <li>View <strong>all group transactions</strong> and <strong>interest</strong> at a glance</li>
              </ul>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-4">For Members</h3>
              <ul className="space-y-2 ml-5">
                <li>Join via QR code or link</li>
                <li>Deposit safely and <strong>earn interest</strong> on your savings</li>
                <li>Track your <strong>balance</strong> and <strong>interest</strong> in real time</li>
                <li>Withdraw via <strong>Visa/Mastercard</strong> or a <strong>virtual card</strong></li>
              </ul>
            </div>
          </div>

          <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm mt-6">
            <h3 className="text-xl font-bold mb-3">Smart Redemption & Investing</h3>
            <p>
              Redeem at large retailers with member discounts. We'll nudge you to keep building wealth —
              <strong> transfer part of your payout into an investment/savings wallet</strong> instead of cashing everything out.
            </p>
          </div>
        </div> */}
      </section>

      {/* Benefits */}
      <section id="benefits" className="py-16 bg-gray-50"
        style={{
            background: "url('Images/background.jpg')",
            backgroundSize: 'cover',
            backgroundPosition:"75% 0",
            backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container mx-auto px-5 max-w-6xl">
          <h2 className="text-3xl font-bold mb-6 text-white">Member Benefits</h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-3">Bank-Grade Safety</h3>
              <p>Managed by <strong>Sharenet</strong>.</p>
            </div>

            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-3">Transparent by Design</h3>
              <p>Blockchain ledger for clear, auditable contributions and payouts.</p>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-3">Earn Interest</h3>
              <p>Your savings earn interest. Sharenet retains a small bank rebate and <strong>pays the rest to members</strong>.</p>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-3">Flexible Payouts</h3>
              <p>Withdraw via Visa/Mastercard debit cards or secure virtual cards — no risky cash handling.</p>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-3">Retailer Discounts</h3>
              <p>Unlock partner discounts when redeeming your stokvel savings at major retailers.</p>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-3">Affordable</h3>
              <p>One-time joining fee of <strong>R50</strong>. <strong>No limits on group size</strong>.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Graduate Agents */}
      <section id="agents" className="py-16">
        <div className="container mx-auto px-5 max-w-6xl">
          <h2 className="text-3xl font-bold mb-2">Graduate Agents — Earn & Empower</h2>
          <p className="text-gray-600 mb-6">
            We hire and train <strong>unemployed graduates</strong> as community Agents to spread the word and teach grassroots financial literacy.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-6">
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-4">What You'll Do</h3>
              <ul className="space-y-2 ml-5">
                <li>Promote Mzansi in communities</li>
                <li>Help leaders set up groups</li>
                <li>Onboard members & guide first deposits</li>
                <li>Teach financial basics using the app</li>
              </ul>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-4">How You'll Earn</h3>
              <ul className="space-y-2 ml-5">
                <li>Reward per member sign-up</li>
                <li>Extra reward per successful deposit</li>
                <li>Unlimited income potential — you decide</li>
              </ul>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <h3 className="text-xl font-bold mb-4">Training You'll Receive</h3>
              <ul className="space-y-2 ml-5">
                <li>Financial concepts & literacy</li>
                <li>App demos & onboarding flow</li>
                <li>Community engagement skills</li>
              </ul>
            </div>
          </div>

          <div id="join" className="flex gap-3 flex-wrap">
            <a 
              href="#" 
              className="bg-cyan-400 text-white px-5 py-3 rounded-lg font-bold text-decoration-none hover:bg-cyan-500 transition-colors"
            >
              Apply to Become an Agent
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.agent.mzansi"
              className="bg-gray-100 text-gray-900 px-5 py-3 rounded-lg font-bold text-decoration-none hover:bg-gray-200 transition-colors"
            >
              Download the App & Join
            </a>
          </div>
        </div>
      </section>

      {/* About */}
      <section id="about" className="py-16">
        <AboutMzansiStokvel/>
      </section>
    </div>
  );
};

export default MzansiStokvel;
